import { useTranslation } from "react-i18next";
import {
  useCreateAiAssignment,
  useGetAiAssignment,
  getAiAssignment,
} from "@packages/api/madlenAPI";
import {
  AiAssignmentCreateRequestDtoCourseName,
  AiAssignmentResponseDto,
} from "@packages/api/madlenAPI.schemas";
import GenericToolCreationPage from "../../../components/tool_components/GenericToolCreationPage";
import {
  AiAssignmentDesignerCreateModal,
  CreateModalProps,
} from "@features/tools/components/create-modal/modals";
import AiAssignmentCard from "@features/tools/components/ai-assignment-designer/AiAssignmentCard";

const CreateAiAssignmentDesignerView = () => {
  const { t } = useTranslation();

  const CreateModalWrapper = ({
    initialInput,
    onSubmit,
    isLoading,
    error,
  }: Partial<CreateModalProps>) => (
    <AiAssignmentDesignerCreateModal
      title={t("aiAssignmentDesigner.createButton")}
      backPath={`/content/ai-assignment-designer`}
      loadingTitle={t("aiAssignmentDesigner.loading_description")}
      errorTitle={t("aiAssignmentDesigner.error.title")}
      errorDescription={t("aiAssignmentDesigner.error.description")}
      submitButtonText={t("common.generate")}
      initialInput={initialInput!}
      onSubmit={async (input) => {
        await onSubmit!(input);
      }}
      isLoading={isLoading!}
      error={error!}
    />
  );

  const ToolCardWrapper = ({
    toolData,
    isImageLoading,
    onCreateAgain,
  }: {
    toolData: AiAssignmentResponseDto;
    isImageLoading?: boolean;
    onCreateAgain: () => void;
  }) => (
    <AiAssignmentCard
      assignment={toolData}
      isImageLoading={isImageLoading}
      onCreateAgain={onCreateAgain}
    />
  );

  return (
    <GenericToolCreationPage
      toolType="ai-assignment-designer"
      useCreateTool={useCreateAiAssignment}
      useGetTool={useGetAiAssignment}
      getTool={getAiAssignment}
      ToolCard={ToolCardWrapper}
      CreateModalWrapper={CreateModalWrapper}
      toolDataExtractor={(data: AiAssignmentResponseDto) =>
        data?.studentInstructions
      }
    />
  );
};

export default CreateAiAssignmentDesignerView;
